module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'eventList') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "returnEmpty": true,
      "singleSelection": true
    }
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始動作",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414b9b6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnEmpty.vue
// module id = 1449
// module chunks = 1